export enum DoorTopChannel {
  FLUSH = 'Flush Channel (STD)',
  INVERT = 'Inverted Channel',
}

export enum DoorBottomChannel {
  FLUSH = 'Flush Channel',
  INVERT = 'Inverted Channel (STD)',
}
